/* tslint:disable */
/* eslint-disable */
/**
 * API Gateway
 * This API provides user authentication and profile management.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime'
import type { V1AuthMePayloadLocation } from './V1AuthMePayloadLocation'
import {
    V1AuthMePayloadLocationFromJSON,
    V1AuthMePayloadLocationFromJSONTyped,
    V1AuthMePayloadLocationToJSON,
    V1AuthMePayloadLocationToJSONTyped
} from './V1AuthMePayloadLocation'

/**
 *
 * @export
 * @interface V1AuthMePayload
 */
export interface V1AuthMePayload {
    /**
     * User public ID (populated from JWT claims)
     */
    id?: string
    /**
     *
     */
    tocConcent?: number
    /**
     *
     */
    ppConcent?: number
    /**
     *
     */
    login: string
    /**
     *
     */
    bio?: string
    /**
     *
     */
    goal?: string
    /**
     *
     */
    age?: string
    /**
     *
     */
    language: string
    /**
     * IANA timezone of the device (marketing quiet hours)
     */
    timezone?: string
    /**
     * The user opted out of the public leaderboard.
     */
    leaderboardHidden?: boolean
    /**
     *
     */
    location?: V1AuthMePayloadLocation
}

/**
 * Check if a given object implements the V1AuthMePayload interface.
 */
export function instanceOfV1AuthMePayload(
    value: object
): value is V1AuthMePayload {
    if (!('login' in value) || value['login'] === undefined) return false
    if (!('language' in value) || value['language'] === undefined) return false
    return true
}

export function V1AuthMePayloadFromJSON(json: any): V1AuthMePayload {
    return V1AuthMePayloadFromJSONTyped(json, false)
}

export function V1AuthMePayloadFromJSONTyped(
    json: any,
    ignoreDiscriminator: boolean
): V1AuthMePayload {
    if (json == null) {
        return json
    }
    return {
        id: json['id'] == null ? undefined : json['id'],
        tocConcent:
            json['toc_concent'] == null ? undefined : json['toc_concent'],
        ppConcent: json['pp_concent'] == null ? undefined : json['pp_concent'],
        login: json['login'],
        bio: json['bio'] == null ? undefined : json['bio'],
        goal: json['goal'] == null ? undefined : json['goal'],
        age: json['age'] == null ? undefined : json['age'],
        language: json['language'],
        timezone: json['timezone'] == null ? undefined : json['timezone'],
        leaderboardHidden:
            json['leaderboardHidden'] == null
                ? undefined
                : json['leaderboardHidden'],
        location:
            json['location'] == null
                ? undefined
                : V1AuthMePayloadLocationFromJSON(json['location'])
    }
}

export function V1AuthMePayloadToJSON(json: any): V1AuthMePayload {
    return V1AuthMePayloadToJSONTyped(json, false)
}

export function V1AuthMePayloadToJSONTyped(
    value?: V1AuthMePayload | null,
    ignoreDiscriminator: boolean = false
): any {
    if (value == null) {
        return value
    }

    return {
        id: value['id'],
        toc_concent: value['tocConcent'],
        pp_concent: value['ppConcent'],
        login: value['login'],
        bio: value['bio'],
        goal: value['goal'],
        age: value['age'],
        language: value['language'],
        timezone: value['timezone'],
        leaderboardHidden: value['leaderboardHidden'],
        location: V1AuthMePayloadLocationToJSON(value['location'])
    }
}
